import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  mode: 'grid',
  page: null,
  pages: null,
  isPublic: false
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
